export default function translate(i18n, propriete) {
  if (propriete === 'libelle') {
    return i18n.t('editionFormatAffiche.fields.libelle');
  }
  if (propriete === 'code') {
    return i18n.t('editionFormatAffiche.fields.code');
  }
  if (propriete === 'typeMaterielId') {
    return i18n.t('editionFormatAffiche.fields.typeMateriel');
  }
  if (propriete === 'natureSupportAfficheId') {
    return i18n.t('editionFormatAffiche.fields.natureSupportAffiche');
  }
  if (propriete === 'largeur') {
    return i18n.t('editionFormatAffiche.fields.largeur');
  }
  if (propriete === 'longueur') {
    return i18n.t('editionFormatAffiche.fields.longueur');
  }
  return propriete;
}
